export default __webpack_public_path__ + "static/NonRental-f2f76db7821727b83d25be23abe110e2.svg";